import React from 'react'
import dynamic from 'next/dynamic'
import VideoLoader from './video-loader'

const VideoPlayerContent = dynamic(() => import('./video-player-content'), {
    ssr: false,
    loading: VideoLoader,
})

export interface VideoPlayerProps {
    src: string
    isActive?: boolean
    autoplay?: boolean
    analyticsCategory?: string
    analyticsLabel?: string
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
    src,
    isActive = true,
    autoplay = false,
    analyticsCategory,
    analyticsLabel,
}) => {
    return (
        <VideoPlayerContent
            src={src}
            isActive={isActive}
            autoplay={autoplay}
            analyticsCategory={analyticsCategory}
            analyticsLabel={analyticsLabel}
        />
    )
}

export default VideoPlayer
